import { useMemo } from "react";
import { useRouteError } from "react-router-dom";
import classes from "./Error.module.css";
import SlsTitle from "./../UI/SlsTitle";

function Error() {
  const error = useRouteError();
  const { status, data } = error || {};
  const { title, message } = useMemo(() => {
    let title = "Une erreur s'est produite !";
    let message = "Quelque chose s'est mal passé !";

    if (status === 500 && data?.message) {
      message = data.message;
    }

    if (status === 404) {
      title = "Page non trouvée !";
      message = "La ressource ou la page demandée est introuvable.";
    }

    return { title, message };
  }, [status, data]);

  return (
    <div className={classes.container}>
      <h1 className={classes.status}>{status}</h1>
      <SlsTitle title={title} text={message} />
    </div>
  );
}

export default Error;
